import { render } from "./UserChip.vue?vue&type=template&id=d518dd22&ts=true"
import script from "./UserChip.vue?vue&type=script&lang=ts"
export * from "./UserChip.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./UserChip.vue?vue&type=style&index=0&id=d518dd22&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__